import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "insights__overview q-col-gutter-sm q-mb-md" }
const _hoisted_2 = { class: "legend" }
const _hoisted_3 = {
  class: "row",
  style: {"margin-bottom":"1rem"}
}
const _hoisted_4 = { class: "row items-center q-gutter-sm" }
const _hoisted_5 = { class: "insight-filters" }
const _hoisted_6 = { class: "filters__item date-range-value" }
const _hoisted_7 = { class: "medium separate-left" }
const _hoisted_8 = { class: "row items-center justify-end q-gutter-sm" }
const _hoisted_9 = { class: "filters__item" }
const _hoisted_10 = { class: "row q-gutter-sm full-width" }
const _hoisted_11 = { class: "chart-block col-6" }
const _hoisted_12 = {
  key: 1,
  class: "chart-skeleton chart-skeleton__barchart"
}
const _hoisted_13 = {
  key: 2,
  class: "full-height flex justify-center items-center"
}
const _hoisted_14 = { class: "chart-block" }
const _hoisted_15 = {
  key: 1,
  class: "chart-skeleton chart-skeleton__areachart"
}
const _hoisted_16 = {
  key: 2,
  class: "full-height flex justify-center items-center"
}
const _hoisted_17 = { class: "row q-gutter-sm full-width" }
const _hoisted_18 = { class: "chart-block col-6" }
const _hoisted_19 = {
  key: 1,
  class: "chart-skeleton chart-skeleton__barchart"
}
const _hoisted_20 = {
  key: 2,
  class: "full-height flex justify-center items-center"
}
const _hoisted_21 = { class: "chart-block" }
const _hoisted_22 = {
  key: 0,
  class: "chart-block__inner",
  style: {"display":"flex"}
}
const _hoisted_23 = {
  key: 1,
  class: "chart-skeleton chart-skeleton__boxplot space-v2",
  style: {"display":"flex","gap":"20px"}
}
const _hoisted_24 = {
  key: 2,
  class: "full-height flex justify-center items-center"
}
const _hoisted_25 = {
  key: 0,
  class: "row full-width q-mt-lg"
}
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "row q-mt-md q-gutter-sm" }
const _hoisted_28 = { class: "chart-block" }
const _hoisted_29 = { class: "graph-header row" }
const _hoisted_30 = { class: "bold" }
const _hoisted_31 = {
  key: 1,
  class: "placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_count_to = _resolveComponent("count-to")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_chart_skeleton = _resolveComponent("chart-skeleton")!
  const _component_area_chart = _resolveComponent("area-chart")!
  const _component_boxplot = _resolveComponent("boxplot")!
  const _component_page = _resolveComponent("page")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_page, {
    class: "padded",
    "hide-nav": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_count_to, {
              class: "statbox",
              value: _ctx.count.orders,
              label: "Orders received",
              "min-duration": 300,
              large: "",
              track: ""
            }, null, 8, ["value"]),
            _createVNode(_component_count_to, {
              class: "statbox",
              value: _ctx.count.revenue,
              label: "Total order revenue",
              interpolate: 1,
              unit: "€",
              "prepend-unit": "",
              "min-duration": 300,
              large: "",
              track: ""
            }, null, 8, ["value"]),
            _createVNode(_component_count_to, {
              class: "statbox",
              value: _ctx.count.product_average,
              label: "Average products per order",
              "min-duration": 300,
              large: "",
              track: ""
            }, null, 8, ["value"]),
            _createVNode(_component_count_to, {
              class: "statbox",
              value: _ctx.count.issues,
              label: "Order processing issues",
              "min-duration": 300,
              large: "",
              track: ""
            }, null, 8, ["value"])
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_d_button, {
                  class: "filters__button",
                  flat: "",
                  onClick: _ctx.showInsightFilters
                }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "t-icon" }, "\"", -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "filters__button--content" }, "Filters    ", -1)),
                    _createElementVNode("span", _hoisted_7, "   " + _toDisplayString(_ctx.formatDate(_ctx.timerange.start)) + " to " + _toDisplayString(_ctx.formatDate(_ctx.timerange.end)), 1),
                    _createVNode(_component_q_popup_proxy, {
                      class: "filters-modal",
                      cover: "",
                      "transition-show": "scale",
                      "transition-hide": "scale"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card, { class: "filters-modal-container" }, {
                          default: _withCtx(() => [
                            _cache[2] || (_cache[2] = _createElementVNode("h6", { class: "bold" }, "Time range", -1)),
                            _createVNode(_component_q_date, {
                              modelValue: _ctx.proxyTimeRange,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.proxyTimeRange) = $event)),
                              range: ""
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                  _withDirectives(_createVNode(_component_q_btn, {
                                    label: "Cancel",
                                    color: "primary",
                                    flat: ""
                                  }, null, 512), [
                                    [_directive_close_popup]
                                  ]),
                                  _withDirectives(_createVNode(_component_q_btn, {
                                    label: "OK",
                                    color: "primary",
                                    flat: "",
                                    onClick: _ctx.save
                                  }, null, 8, ["onClick"]), [
                                    [_directive_close_popup]
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_q_select, {
                  modelValue: _ctx.selectedItems,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems) = $event)),
                  multiple: "",
                  outlined: "",
                  round: "",
                  dense: "",
                  filled: "",
                  "use-chips": "",
                  "emit-value": "",
                  label: "Channels",
                  options: Object.values(_ctx.dictionaries.catalogues).filter(Boolean)
                }, null, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "graph-header row" }, [
              _createElementVNode("h5", { class: "bold" }, "Order count")
            ], -1)),
            (!_ctx.loading && _ctx.charts.ordersByCatalogueDay.data.length > 0)
              ? (_openBlock(), _createBlock(_component_bar_chart, {
                  key: 0,
                  payload: _ctx.charts.ordersByCatalogueDay.data,
                  config: _ctx.charts.ordersByCatalogueDay.options
                }, null, 8, ["payload", "config"]))
              : (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_chart_skeleton, {
                      size: 25,
                      style: {"height":"280px","opacity":".6"}
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, "No data available"))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "graph-header row" }, [
              _createElementVNode("h5", { class: "bold" }, "Average products per order")
            ], -1)),
            (!_ctx.loading && _ctx.charts.productAvgPerOrdersByDay.data.length > 0)
              ? (_openBlock(), _createBlock(_component_area_chart, {
                  key: 0,
                  payload: _ctx.charts.productAvgPerOrdersByDay.data,
                  config: _ctx.charts.productAvgPerOrdersByDay.options
                }, null, 8, ["payload", "config"]))
              : (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(_component_chart_skeleton, {
                      size: 25,
                      style: {"height":"280px","opacity":".6"}
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, "No data available"))
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "graph-header row" }, [
              _createElementVNode("h5", { class: "bold" }, "Average value per order")
            ], -1)),
            (!_ctx.loading && _ctx.charts.valueAvgPerOrdersByDay.data.length > 0)
              ? (_openBlock(), _createBlock(_component_bar_chart, {
                  key: 0,
                  payload: _ctx.charts.valueAvgPerOrdersByDay.data,
                  config: _ctx.charts.valueAvgPerOrdersByDay.options
                }, null, 8, ["payload", "config"]))
              : (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_chart_skeleton, {
                      size: 25,
                      style: {"height":"280px","opacity":".6"}
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, "No data available"))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "graph-header row" }, [
              _createElementVNode("h5", { class: "bold" }, "Picking & Packing times")
            ], -1)),
            (!_ctx.loading && _ctx.charts.PickingOrdersByDay.data.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_boxplot, {
                    payload: _ctx.charts.PickingOrdersByDay.data,
                    config: _ctx.charts.PickingOrdersByDay.options,
                    style: {"width":"50%"}
                  }, null, 8, ["payload", "config"]),
                  _createVNode(_component_boxplot, {
                    payload: _ctx.charts.PackingOrdersByDay.data,
                    config: _ctx.charts.PackingOrdersByDay.options,
                    style: {"width":"50%"}
                  }, null, 8, ["payload", "config"])
                ]))
              : (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_chart_skeleton, {
                      size: 25,
                      style: {"height":"280px","opacity":".6"}
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, "No data available"))
          ])
        ]),
        (Object.keys(_ctx.shopifyToArea || {}).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("section", _hoisted_26, [
                _cache[11] || (_cache[11] = _createElementVNode("h5", { class: "bold" }, [
                  _createElementVNode("span", { class: "bold" }, "Service Insights"),
                  _createElementVNode("span", null, " — Shopify")
                ], -1)),
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shopifyToArea, (items, service) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.format.title(service)), 1)
                      ]),
                      (items?.length)
                        ? (_openBlock(), _createBlock(_component_area_chart, {
                            key: 0,
                            payload: items,
                            config: _ctx.charts.productAvgPerOrdersByDay.options
                          }, null, 8, ["payload", "config"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_31, "No data to show"))
                    ]))
                  }), 256))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}